(() => {
  const root = document.querySelector('.main-content') || document.querySelector('.product-single-wrapper');
  if (!root || !document.body.classList.contains('template-product')) return;
  const names = [
    ['Additional Note Pages', 'Extra Notes Pages', 'Extra space for lists, notes, and ideas.'],
    ['Meal Planning Section', 'Meal Planning Section', 'Plan meals, groceries, and weekly menus in one place.'],
    ['Budget Planning Section', 'Budget Planning Section', 'Manage spending, savings, and financial goals.'],
    ['Additional Pocket/Pouch', 'Additional Pocket', 'Store receipts, notes, stickers, and keepsakes.']
  ];
  let pending = false;
  const observer = new MutationObserver(records => {
    if (records.some(r => r.addedNodes.length || r.type === 'characterData')) schedule();
  });
  const observe = () => observer.observe(root, {childList:true, subtree:true, characterData:true});
  function update() {
    pending = false;
    observer.disconnect();
    root.querySelectorAll('.pplrlabel').forEach(label => {
      Array.from(label.childNodes).filter(n => n.nodeType === 3).forEach(node => {
        if (/personalization for front cover|personalize your cover/i.test(node.nodeValue)) node.nodeValue = 'Add Your Name or Phrase';
      });
    });
    root.querySelectorAll('.product-personalizer').forEach(el => {
      if (el.dataset.posyStyled) return;
      el.removeAttribute('style');
      el.querySelectorAll('[style]').forEach(child => child.removeAttribute('style'));
      el.dataset.posyStyled = 'true';
    });
    root.querySelectorAll('input[name="properties[Personalization for front cover]"]').forEach(input => {
      if (input.placeholder !== 'Enter personalization here') input.placeholder = 'Enter personalization here';
      if (!input.hasAttribute('aria-label')) input.setAttribute('aria-label', 'Name or phrase for the planner cover');
    });
    const title = root.querySelector('.lb-upsell-ppa-title');
    if (title && !root.querySelector('.custom-upsell-subtext')) {
      const p = document.createElement('p');
      p.className = 'custom-upsell-subtext';
      p.textContent = 'Add extra planning sections and accessories.';
      title.after(p);
    }
    root.querySelectorAll('.lb-upsell-product-page-card').forEach(card => {
      const name = card.querySelector('.lb-spc-details-name');
      if (!name) return;
      const entry = names.find(n => name.textContent.includes(n[0]) || name.textContent.trim() === n[1]);
      if (!entry) return;
      if (name.textContent.trim() !== entry[1]) name.textContent = entry[1];
      let description = card.querySelector('.custom-upsell-text');
      if (!description) { description = document.createElement('p'); description.className = 'custom-upsell-text'; name.after(description); }
      if (description.textContent !== entry[2]) description.textContent = entry[2];
      const checkbox = card.querySelector('input[type="checkbox"]');
      if (checkbox && !checkbox.hasAttribute('aria-label')) checkbox.setAttribute('aria-label', 'Add ' + entry[1]);
      const select = card.querySelector('select');
      if (select && !select.hasAttribute('aria-label')) select.setAttribute('aria-label', 'Choose option for ' + entry[1]);
    });
    observe();
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
  update();
})();
